var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from "react";
import ProductStoresView from "../presentation/shopping-list-stores";
import axios from 'axios';
import { connect } from "react-redux";
const _ = require('lodash');
const pcluster = require('points-cluster');
const supercluster = pcluster.default;
import * as actions from "../actions/";
import CONSTS from "../consts";
const MAP = {
    defaultZoom: 6,
    defaultCenter: { lat: 53.542741, lng: -113.4912073 }
};
export class ShoppingListStores extends React.Component {
    constructor(props) {
        super(props);
        this.getLocation = (position) => {
            this.setState({
                mapOptions: Object.assign(Object.assign({}, this.state.mapOptions), { center: { lat: position.coords.latitude, lng: position.coords.longitude }, zoom: 16 })
            });
        };
        this.updateFilter = (option) => {
            let amenitesFilter = Object.assign({}, this.state.amenitesFilter);
            amenitesFilter[option] = !amenitesFilter[option];
            this.setState({
                amenitesFilter
            }, () => {
                this.getStores(this.props.shoppingList);
            });
        };
        this.clearFilter = () => {
            this.setState({
                amenitesFilter: {
                    SpecialEventsOrdering: false,
                    OnSiteSpecialEvents: false,
                    KegSales: false,
                    OnSiteKitchen: false,
                    DeliveryService: false,
                    SpecialOrdering: false,
                    OnlineOrdering: false,
                    SommelierOnStaff: false,
                    LicenseeSales: false
                }
            }, () => {
                this.getStores(this.props.shoppingList);
            });
        };
        this.clusterMarkerClick = (position) => {
            this.setState({
                mapOptions: Object.assign(Object.assign({}, this.state.mapOptions), { center: { lat: position.lat, lng: position.lng }, zoom: this.state.mapOptions.zoom + 2 })
            });
        };
        this.MarkerClick = (position) => {
            this.setState({
                mapOptions: Object.assign(Object.assign({}, this.state.mapOptions), { center: { lat: position.lat, lng: position.lng }, zoom: 16 })
            });
        };
        this.updateSelected = (newStore) => {
            this.setState({ selected: newStore });
        };
        this.toggleList = (store) => {
            store === this.state.showList ?
                this.setState({ showList: null }) :
                this.setState({ showList: store });
        };
        this.getClusters = () => {
            let markersData = this.state.stores.map((store, index) => {
                return {
                    lat: store.Latitude,
                    lng: store.Longitude,
                    storeIndex: store.storeIndex + 1,
                    id: store.Id,
                    storeInfo: store
                };
            });
            const clusters = supercluster(markersData, {
                minZoom: 0,
                maxZoom: 16,
                radius: 60,
            });
            return clusters(this.state.mapOptions);
        };
        this.createClusters = () => {
            this.setState({
                clusters: this.state.mapOptions.bounds
                    ? this.getClusters().map(({ wx, wy, numPoints, points }) => ({
                        lat: wy,
                        lng: wx,
                        numPoints,
                        id: `${numPoints}_${points[0].id}`,
                        points,
                    }))
                    : [],
            });
        };
        this.handleMapChange = ({ center, zoom, bounds }) => {
            this.setState({
                mapOptions: {
                    center,
                    zoom,
                    bounds,
                },
            }, () => {
                this.createClusters();
                this.getStores(this.props.shoppingList);
            });
        };
        this.updateToggle = (toggle) => {
            this.setState({ toggleMobile: toggle });
        };
        this.updateMobileFilter = () => {
            this.setState({ mobileFilter: !this.state.mobileFilter });
        };
        this.updateAddressText = (newAddress) => {
            this.setState({ addressText: newAddress }, this.getAddressLatLng);
        };
        this.state = {
            stores: [],
            products: [],
            clusters: [],
            amenitesFilter: {
                SpecialEventsOrdering: false,
                OnSiteSpecialEvents: false,
                KegSales: false,
                OnSiteKitchen: false,
                DeliveryService: false,
                SpecialOrdering: false,
                OnlineOrdering: false,
                SommelierOnStaff: false,
                LicenseeSales: false
            },
            name: "",
            selected: "",
            mapOptions: {
                center: MAP.defaultCenter,
                zoom: MAP.defaultZoom,
            },
            showList: null,
            toggleMobile: false,
            mobileFilter: false,
            addressText: ""
        };
    }
    getStores(slist) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (slist.length) {
                    this.props.toggleLoading();
                    let oDataPath = CONSTS.APIURL;
                    let filterStr = slist.reduce((total, currentValue, index) => {
                        return index === 0 ? `${total}` : `${total}+or+DisplaySKU+eq+${currentValue}`;
                    }, `DisplaySKU+eq+${slist[0] || ""}`);
                    let subFilterStr = slist.reduce((total, currentValue, index) => {
                        return index === 0 ? `${total}` : `${total}+or+o/DisplaySKU+eq+${currentValue}`;
                    }, `o/DisplaySKU+eq+${slist[0] || ""}`);
                    let amenitesList = [];
                    _.forOwn(this.state.amenitesFilter, (value, key) => {
                        if (value) {
                            amenitesList.push(key);
                        }
                    });
                    let amenitesStr = amenitesList.map((currentValue, index) => {
                        return `${currentValue}+eq+true`;
                    }).join("+and+");
                    let queryStart = "";
                    if (this.state.mapOptions.bounds == null) {
                        queryStart = `${oDataPath}Suppliers?$expand=Products`;
                    }
                    else {
                        var bounds = this.state.mapOptions.bounds;
                        var boundsText = `east=${bounds.ne.lng || 0},west=${bounds.nw.lng || 0},north=${bounds.nw.lat || 0},south=${bounds.se.lat || 0}`;
                        queryStart = `${oDataPath}Suppliers/ConnectMobile.Web.AllWithinBounds(${boundsText})?$expand=Products`;
                    }
                    let query = queryStart +
                        `($filter=(${filterStr});$select=Name,DisplaySKU)` +
                        `&$filter=Products/any(o: (${subFilterStr}))${amenitesList.length > 0 ? "and+" + amenitesStr : ""}`;
                    const ShoppingPromise = yield axios.get(query);
                    let favoriteStores = this.props.favoriteStores;
                    let stores = _.chain(ShoppingPromise.data.value)
                        .sortBy([
                        function (o) { return -favoriteStores.indexOf(o.Id); },
                        function (o) { return -o.Products.length; }
                    ])
                        .map((store, index) => {
                        return Object.assign(Object.assign({}, store), { storeIndex: index });
                    }).value();
                    this.setState({
                        stores
                    });
                    this.createClusters();
                    this.props.toggleLoading();
                }
            }
            catch (e) {
                this.props.toggleLoading();
            }
        });
    }
    getShoppingList(slist) {
        return __awaiter(this, void 0, void 0, function* () {
            if (slist.length) {
                let oDataPath = CONSTS.APIURL;
                let filterStr = slist.reduce((total, currentValue, index) => {
                    return index === 0 ? `${total}` : `${total}+or+DisplaySKU+eq+${currentValue}`;
                }, `DisplaySKU+eq+${slist[0] || ""}`);
                let query = `${oDataPath}Products?$filter=(${filterStr})&$select=DisplaySKU,Name`;
                const ShoppingPromise = yield axios.get(query);
                this.setState({
                    products: ShoppingPromise.data.value
                });
            }
        });
    }
    componentDidMount() {
        if (this.props.shoppingList && this.props.favoriteStores) {
            this.getStores(this.props.shoppingList);
        }
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.shoppingList !== this.props.shoppingList) {
            this.getStores(nextProps.shoppingList);
            this.getShoppingList(nextProps.shoppingList);
        }
        if (nextProps.favoriteStores !== this.props.favoriteStores) {
            this.getStores(nextProps.shoppingList);
            this.getShoppingList(nextProps.shoppingList);
        }
    }
    getAddressLatLng() {
        return __awaiter(this, void 0, void 0, function* () {
            var geocoder = new google.maps.Geocoder();
            geocoder.geocode({
                address: this.state.addressText,
                bounds: {
                    east: -109,
                    south: 48,
                    west: -121,
                    north: 61,
                }
            }, (results, status) => {
                if (status === google.maps.GeocoderStatus.OK && results != null && results.length > 0) {
                    this.setState({
                        mapOptions: Object.assign(Object.assign({}, this.state.mapOptions), { center: { lat: results[0].geometry.location.lat(), lng: results[0].geometry.location.lng() }, zoom: 13 })
                    }, () => this.getStores(this.props.shoppingList));
                }
            });
        });
    }
    render() {
        return (React.createElement(ProductStoresView, Object.assign({}, this.state, { updateToggle: this.updateToggle, shoppingList: this.props.shoppingList, getLocation: this.getLocation, updateSelected: this.updateSelected, handleMapChange: this.handleMapChange, toggleList: this.toggleList, MarkerClick: this.MarkerClick, clusterMarkerClick: this.clusterMarkerClick, updateFilter: this.updateFilter, updateMobileFilter: this.updateMobileFilter, clearFilter: this.clearFilter, updateAddressText: this.updateAddressText })));
    }
}
;
export function mapStateToProps({ shoppingList, authenticated, signInModal, favoriteStores }) {
    return {
        shoppingList,
        favoriteStores
    };
}
export function mapDispatchToProps(dispatch) {
    return {
        toggleLoading: () => dispatch(actions.ToggleLoading())
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(ShoppingListStores);
//# sourceMappingURL=shopping-list-stores.js.map